
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/current-affairs-upsc",
      function () {
        return require("private-next-pages/current-affairs-upsc/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/current-affairs-upsc"])
      });
    }
  